module.exports = __webpack_public_path__ + "img/rwxx.5c1b2de4.svg";